// The Data Processing Agreement text, in one place so it can be replaced
// wholesale once legal review is done. Bump DPA_VERSION in service/routes.py
// whenever this text changes.
export const dpaText = {
  heading: "DRAFT, pending legal review",
  updated: "Draft: October 2026",
  sections: [
    {
      title: "Placeholder",
      body: "This is placeholder text, not a binding agreement. The Data Processing Agreement between Executive Interview Coach and recruiting firms will be published here once it has been reviewed.",
    },
    {
      title: "Contact",
      body: "Questions about data processing should be directed to: legal@executiveinterview.coach",
    },
  ],
};
